import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import girl from "../assets/kangaroo/joinsuccessimage.png";
import Button from "../component/button/Button";
import Form from "../component/Form/Form";
import { imageBaseApi } from "../services/imageBaseApi";

const JoinSuccess = ({ data }) => {
  const router = useNavigate();
  console.log(data);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  return (
    <div
      style={{

        background: "transparent",
        // border:"1px soldi black"
      }}
      className="main-container h-100 "
    >
      <Row className="h-100  align-items-center">
        <Col
          sm={12}
          lg={8}
          className=" d-flex  h-100 align-items-center justify-content-lg-end justify-content-start"
          style={{
            marginLeft: "0",
            marginTop: "0",
            paddingTop: "2rem",
          }}
        >
          <div
            className=" w-100 d-flex flex-column justify-content-start align-items-lg-end align-items-start "
            style={{ maxWidth: "clamp(300px, 80vw, 800px)" }}
          >
            <div
              className="text-start  w-100 ps-lg-5 ps-sm-1 ps-ms-5 pe-2"
              style={{
                // alignSelf: "flex-start",
                // marginLeft: "3rem",
                width: "800px",
                marginTop: isMobile ? "2rem" : "0rem",
              }}
            >
              <h1 className="joinsucess-subtitle fw-normal lh-1 mb-2">
                {data[0]?.heading}
              </h1>
              <h2 className="font-level-4  lh-1 m-0">
                {data[0]?.boldHeading}
              </h2>

              <h3 className="joinsucess-subtitle lh-1 mb-3">
                {data[0]?.subHeading?.split("/n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </h3>


              {/* 5/12 = 41.666% for 5 grid columns */}
              <Button
                label={data[0]?.buttontext}
                margin="20px 0"
                width="350.4053px"
                height="60px"
                fontSize="22px"
                fontWeight="500"
                textColor={data[0]?.buttonColor}
                fontFamily="Proxima Nova Bold"
                onClick={toggleModal}
              />
            </div>
          </div>
          <div>
            <Form
              modal={modalOpen}
              toggle={toggleModal}
              heading=" Be the Next Success Story:  Start Smart with Kangaroo"
              description=" Fill out your details and take the first step toward your study
              abroad journey."
              closingMessage="YOU'RE ONE STEP CLOSER TO STARTING SMART!"
              closingDesc="Our counselor will connect with you shortly"
              formOrigin={3}
            />
          </div>
        </Col>
        <Col
          lg={4}
          sm={12}
          className="d-flex   p-0 mt-auto"

        >


          <img
            // src={girl}
            src={imageBaseApi + data[0]?.media?.url}
            fluid
            className="img-fluid girl-image "
            style={{ marginLeft: isMobile ? "5rem" : "0rem", }}
          />

        </Col>
      </Row>
    </div>
  );
};

export default JoinSuccess;
